import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"],
  _excluded2 = ["scope", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// packages/react/context/src/createContext.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
function createContext2(rootComponentName, defaultContext) {
  var Context = React.createContext(defaultContext);
  function Provider(props) {
    var children = props.children,
      context = _objectWithoutProperties(props, _excluded);
    var value = React.useMemo(function () {
      return context;
    }, Object.values(context));
    return /* @__PURE__ */jsx(Context.Provider, {
      value: value,
      children: children
    });
  }
  function useContext2(consumerName) {
    var context = React.useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext2];
}
function createContextScope(scopeName) {
  var createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultContexts = [];
  function createContext3(rootComponentName, defaultContext) {
    var BaseContext = React.createContext(defaultContext);
    var index = defaultContexts.length;
    defaultContexts = [].concat(_toConsumableArray(defaultContexts), [defaultContext]);
    function Provider(props) {
      var scope = props.scope,
        children = props.children,
        context = _objectWithoutProperties(props, _excluded2);
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var value = React.useMemo(function () {
        return context;
      }, Object.values(context));
      return /* @__PURE__ */jsx(Context.Provider, {
        value: value,
        children: children
      });
    }
    function useContext2(consumerName, scope) {
      var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
      var context = React.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext2];
  }
  var createScope = function createScope() {
    var scopeContexts = defaultContexts.map(function (defaultContext) {
      return React.createContext(defaultContext);
    });
    return function useScope(scope) {
      var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(scopeName), _objectSpread(_objectSpread({}, scope), {}, _defineProperty({}, scopeName, contexts)));
      }, [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [createContext3, composeContextScopes.apply(void 0, [createScope].concat(_toConsumableArray(createContextScopeDeps)))];
}
function composeContextScopes() {
  for (var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++) {
    scopes[_key] = arguments[_key];
  }
  var baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  var createScope = function createScope() {
    var scopeHooks = scopes.map(function (createScope2) {
      return {
        useScope: createScope2(),
        scopeName: createScope2.scopeName
      };
    });
    return function useComposedScopes(overrideScopes) {
      var nextScopes = scopeHooks.reduce(function (nextScopes2, _ref2) {
        var useScope = _ref2.useScope,
          scopeName = _ref2.scopeName;
        var scopeProps = useScope(overrideScopes);
        var currentScope = scopeProps["__scope".concat(scopeName)];
        return _objectSpread(_objectSpread({}, nextScopes2), currentScope);
      }, {});
      return React.useMemo(function () {
        return _defineProperty({}, "__scope".concat(baseScope.scopeName), nextScopes);
      }, [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}
export { createContext2 as createContext, createContextScope };